import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { tipoGlobalInfo, UsuarioModel } from '../models/usuario.model';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  data: tipoGlobalInfo;
  private allUser = 'https://sesiones-live-red-default-rtdb.firebaseio.com';
  private inscritos = 'https://sesiones-live-red-default-rtdb.firebaseio.com/webinars/';

  constructor(
    private firestore : AngularFirestore, 
    private http : HttpClient
  ) { }

  addUser( user:UsuarioModel ) {
    
    return this.http.post(`${ this.allUser }/webinars/users1803.json`, user )
      .pipe(
        map( ( resp:any ) => {
          user.id = resp.name;
        })
      );

  }
  actualizarUser( user:UsuarioModel ){
    const userTemp = {
      ...user
    };
    delete userTemp.id;
    return this.http.put(`${ this.allUser }/webinars/users1803/${ user.id }.json`, userTemp );
  }

  //Crea un nuevo gato
  public createCat() {
    return this.firestore.collection('liveinfo').add( this.data );
  } 

  //Obtiene un gato
  public getCat(documentId: string) {
    return this.firestore.collection('liveinfo').doc(documentId).snapshotChanges();
  }  
  //Obtiene todos los gatos
  public getCats() {
    return this.firestore.collection('liveinfo').snapshotChanges();
  } 
  //Actualiza un gato
  public updateCat(documentId: string, data: tipoGlobalInfo ) {
    return this.firestore.collection('liveinfo').doc(documentId).set(data);
  }
  

  // tabla real time database
  getInscritos() {
    return this.http.get(`${ this.inscritos }/users1803.json`)
      .pipe(
        map( this.crearArreglo )
      )
  }
  private crearArreglo( inscritosObj: object) {
    const inscritos: UsuarioModel[] = [];
    
    console.log( inscritosObj );
    if ( inscritosObj === null) { return []; };
    
    Object.keys( inscritosObj ).forEach( key =>{
      const participantes: UsuarioModel = inscritosObj[key];
      participantes.id = key;
      inscritos.push( participantes );
    });
    return inscritos;
  }

}
